import Tooltip from './Tooltip'

export * from './Tooltip'
export default Tooltip
